<template v-if="expenses.length">
    <div class="payroll-info-paid-block">
        <div class="main-block" v-loading="loading">
            <template :v-if="expenses.length">
                <div class="title">
                    {{ title }}
                </div>
                <div class="title-row row">
                    <div>
                        Дата
                    </div>
                    <div>
                        Сумма
                    </div>
                </div>
                <div v-for="categoryByDates in expenses" :key="categoryByDates.date">
                    <div class="row" @click="handleСategoryClick(categoryByDates)">
                        <div class="name-total">
                            <i class="el-icon-caret-bottom" v-if="categoryByDates.isOpened"></i>
                            <i class="el-icon-caret-right" v-else></i>
                            <span>{{ categoryByDates.date }}:</span>
                            <span>{{ formatFinance(categoryByDates.sumExpenses) }}</span>
                        </div>
                    </div>
                    <template v-if="1">
                        <div v-for="category in categoryByDates.data" :key="category.categoryName">
                            <template v-if="category.categoryName === 'deals'">
                                <div class="row" @click="handlePositionClick(category)">
                                    <div class="name pl15">
                                        <i class="el-icon-caret-bottom" v-if="category.isOpened"></i>
                                        <i class="el-icon-caret-right" v-else></i>
                                        <span>
                                            {{ getEmployerCalculatedColumnName(category.categoryName) }}
                                        </span>
                                        <span>
                                            {{ formatFinance(category.sumDeals) }}
                                        </span>
                                    </div>
                                </div>
                                <div class="grid-wrapper">
                                    <payroll-info-employer-paid-deals-grid
                                        :expenses="category.expenses"
                                        v-if="category.isOpened"
                                    />
                                </div>
                            </template>
                            <template v-else>
                                <div class="row">
                                    <div class="name pl15 icon-noactive">
                                        <i class="el-icon-caret-bottom" v-if="1"></i>
                                        <span>{{ getEmployerCalculatedColumnName(category.categoryName) }} </span>
                                        <span>{{ category.sum ? formatFinance(category.sum) : 0 }}</span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import '@/assets/styles/payroll-info-paid.scss';
import PayrollInfoEmployerPaidDealsGrid from '@/components/expenses/PayrollInfoEmployerPaidDealsGrid';
import { formatFinance } from '@/common/utilities';
import employerInfoMixin from '@/mixins/employerInfo';
import dateHelper from '@/helpers/dateHelper';

export default {
    name: 'PayrollInfoEmployerPaid',
    components: {
        PayrollInfoEmployerPaidDealsGrid
    },
    props: {
        employerId: {
            type: [Number, String],
            default: 0
        },
        reportDate: {
            type: String,
            default: ''
        }
    },
    mixins: [
        employerInfoMixin
    ],
    data() {
        return {
            amount: [],
            loading: false,
            expenses: [],
            employerPositionId: 0,
            expensesTotalSum: 0
        };
    },
    methods: {
        formatFinance,
        async getExpensesAll(period, employerId) {
            this.loading = true;
            await this.$store.dispatch('expenses/getEmployerExpensesByPeriod', { report_date: period, employer_id: employerId }).then(
                response => {
                    this.expenses = response.expenses;
                    this.employerPositionId = response.employerPositionId;
                    this.dealsTotalSum = response.dealsTotalSum;
                    console.log(this.expenses);
                    console.log(response);
                },
                error => {
                    if (error.response.status === 403) {
                        console.log(error.response.data.error);
                    }
                }
            ).finally(() => { this.loading = false; });
        },
        handleСategoryClick(position) {
            position.isOpened = !position.isOpened;
        },
        handlePositionClick(position) {
            position.isOpened = !position.isOpened;
        },
        getEmployerCalculatedColumnName(columnName) {
            return this.getNameFromListById(this.payrollInfoEmployerCalculateFields, columnName);
        },
        getNameFromListById(list, searchedId) {
            if (Object.keys(list).length !== 0) {
                if (searchedId === 'efficiency_payment') {
                    if (this.employerPositionId === this.localReferences.employerPositions.manager) {
                        searchedId = 'efficiency_payment_manager';
                    } else if (this.employerPositionId === this.localReferences.employerPositions.measurer) {
                        searchedId = 'efficiency_payment_measurer';
                    }
                }
                const foundItem = list.find(item => item.id === searchedId);
                return foundItem ? foundItem.name : '';
            }
            return '';
        }
    },
    computed: {
        title() {
            const date = this.reportDate.split('-');
            return 'Выдано за ' + dateHelper.getMonthName(date[1]) + ' ' + date[0];
        }
    },
    mounted() {
        this.getExpensesAll(this.reportDate, this.employerId);
    }
};
</script>
